import Image from 'next/image'

/* assets */
import { ReactComponent as QuoteIcon } from 'public/assets/icons/quote.svg'

const usps = [
  {
    title: 'Reduce CAC',
    description: 'Boost your rankings with high-quality content',
    icon: '/assets/order/icons/sensor.svg'
  },
  {
    title: 'Scale content creation',
    description: 'Harness the power of human+ ai to create content',
    icon: '/assets/order/icons/pen-tool.svg'
  },
  {
    title: 'Streamline your process',
    description: 'Bring your content, data, and teams together',
    icon: '/assets/order/icons/layout.svg'
  }
]

const brands = [
  {
    url: '/assets/icons/brands/Amazon_pay.svg',
    alt: 'Amazon Pay'
  },
  {
    url: '/assets/icons/brands/Lemlist.svg',
    alt: 'Lemlist'
  },
  {
    url: '/assets/icons/brands/Dormakaba.svg',
    alt: 'Dormakaba'
  },
  {
    url: '/assets/icons/brands/Bosch.svg',
    alt: 'Bosch'
  },
  {
    url: '/assets/icons/brands/Adobe_white.svg',
    alt: 'Adobe'
  },
  {
    url: '/assets/icons/brands/Directi_white.svg',
    alt: 'Directi'
  },
  {
    url: '/assets/icons/brands/Apollo_hospitals.png',
    alt: 'Apollo 24/7'
  },
  {
    url: '/assets/icons/brands/HDFC_Bank.svg',
    alt: 'HDFC Bank'
  }
]

export function LogoSlide() {
  return (
    <div className="text-white | flex items-center justify-center flex-col h-full">
      <h3 className="text-caption font-medium uppercase text-center tracking-wider | mb-4">
        Trusted by 2500+ brands
      </h3>
      <div className="grid grid-cols-2 gap-x-10 gap-y-5 items-center justify-items-center">
        {brands.map(brand => (
          <img
            key={brand.alt}
            src={brand.url}
            alt={brand.alt}
            className="max-h-14 | object-contain"
          />
        ))}
      </div>
    </div>
  )
}

export function TestimonialSlide(props: {
  testimonial: TestimonialListingCard
}) {
  return (
    <div className="text-white | flex items-center justify-center flex-col h-full">
      <QuoteIcon className="text-magenta-40 | mb-4 mx-auto" />

      <p className="text-paragraph-3 text-center | max-w-xs | mb-6">
        {props.testimonial.review}
      </p>

      {props.testimonial.authorImage.data && (
        <Image
          className="rounded-full | h-12 w-12 | mx-auto mb-6"
          src={props.testimonial.authorImage.data.attributes.url}
          alt={props.testimonial.authorName}
          width={96}
          height={96}
        />
      )}
      <p className="text-paragraph-4 font-medium text-center | mb-1">
        {props.testimonial.authorName}
      </p>
      <p className="text-paragraph-4 text-center | mb-6">
        {props.testimonial.authorDesignation} at {props.testimonial.company}
      </p>
    </div>
  )
}

export function UspSlide() {
  return (
    <div className="text-white | flex items-center justify-center flex-col h-full | px-10">
      <h3 className="text-paragraph-2 text-center | mb-14">
        Why use Pepper for your business?
      </h3>
      <div className="w-auto | space-y-6">
        {usps.map(usp => (
          <div key={usp.title} className="flex gap-6">
            <img
              src={usp.icon}
              alt=""
              aria-hidden={true}
              width="24"
              height="24"
            />
            <div>
              <h4 className="text-paragraph-4 font-medium | mb-1">
                {usp.title}
              </h4>
              <p className="text-paragraph-4 text-gray-40">{usp.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
